<div class="modal-header pl-3 pb-3">
  <h1 class="modal-title" id="modal-basic-title">{{ 'envelope.delete-modal.headerEdit' | translate }} </h1>
  <button type="button" class="cdx-btn__close icon" aria-label="Close" (click)="modalClose()">
    <fa-icon fa-fw="true" [icon]="['far','times']"></fa-icon>
  </button>
</div>
<div class="modal-title pl-3 pb-2">
  <h4>{{ 'envelope.delete-modal.subTitle' | translate }}</h4>
</div>
<div class="modal-body mt-n3 pb-2">
  <form #f="ngForm" [formGroup]="envelopeForm">
    <div class="form-row mt-2">
      <div class="form-group col-md-12">
        <label>{{ "envelope.delete-modal.reasonDelete" | translate }}</label>
        <label class="mt-1" style="font-size: small; color: gray;">{{
          "envelope.delete-modal.reasonDeleteComplement" | translate }}</label>
        <div class="mt-2">
          <textarea formControlName="reasonDelete" class="form-control" id="reasonDelete" rows="4"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer pr-3 pb-2 pt-2">
  <div class="row align-items-center justify-content-end pt-1 pb-1">
    <button class="cdx-button cdx-button--tertiary ml-0" (click)="modalClose()">
      <span class="cdx-button__text">{{ 'cancel' | translate | uppercase }}</span>
    </button>
    <button class="cdx-button cdx-button--primary cdx-button--danger ml-0" (click)="onDeleteEnvelope()"
      [disabled]="!(this.envelopeForm.valid)">
      <span class="cdx-button__text">{{ 'envelope.delete-modal.delete' | translate | uppercase}}</span>
    </button>
  </div>
</div>